    // GPA = total quality points / total GPA-eligible units
    // Returns null if units sum to 0 (avoids Infinity/NaN)
   export function getGPA(gradeValuesArray, unitsArray) {
        if (!Array.isArray(gradeValuesArray) || !Array.isArray(unitsArray)) return null;
      
        let totalQualityPoints = 0;
        let totalUnits = 0;
      
        const len = Math.min(gradeValuesArray.length, unitsArray.length);
        for (let i = 0; i < len; i++) {
          const gradeVal = Number(gradeValuesArray[i]);
          const units = Number(unitsArray[i]);
      
          if (Number.isFinite(gradeVal) && Number.isFinite(units) && units > 0) {
            totalQualityPoints += gradeVal * units; // multiply each course grade by its units
            totalUnits += units;
          }
        }
      
        return totalUnits > 0 ? totalQualityPoints / totalUnits : null;
    }